import { render, staticRenderFns } from "./RemoteIcon.vue?vue&type=template&id=20cd814b"
import script from "./RemoteIcon.vue?vue&type=script&lang=js"
export * from "./RemoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports